import { useGetAuthMe } from "@birdwatch/client";
import type { ComponentProps } from "react";
import { useUserDetail } from "@/api/use-user-detail";
import { useUserOnline } from "@/api/use-user-online";
import { AvatarOnline } from "@/components/ui/avatar/avatar-online";
import { Skeleton } from "@/components/ui/skeleton";
import { env } from "@/env";

type UserOnlineAvatarProps = {
  userId?: string;
  size?: ComponentProps<typeof AvatarOnline>["size"];
};

export function UserOnlineAvatar({
  userId,
  size = "md",
}: UserOnlineAvatarProps) {
  const { data: me } = useGetAuthMe().get();
  const { data: user, isLoading } = useUserDetail(userId || "", {
    enabled: !!userId,
  });
  const { data: userOnline } = useUserOnline(userId || "", {
    enabled:
      !!userId &&
      me?.id !== userId &&
      userId !== env.PUBLIC_BIRDWATCH_TEAM_ADMIN_ID,
  });

  const isUserOnline =
    userOnline?.online ||
    me?.id === userId ||
    userId === env.PUBLIC_BIRDWATCH_TEAM_ADMIN_ID;

  if (!userId || isLoading) return <Skeleton className="size-8 rounded-full" />;
  return (
    <AvatarOnline
      size={size}
      isOnline={isUserOnline}
      src={user?.avatarUrl || ""}
      name={user?.name || ""}
      className="shrink-0"
    />
  );
}
